// extracted by mini-css-extract-plugin
module.exports = {"hero-block":"Hero_hero-block__ilFqX","mod-image":"Hero_mod-image__qllCx","hero-block-content":"Hero_hero-block-content__F8_OA","image":"Hero_image__ooh5h"};